import dayjs from 'dayjs'

export function calculateAge(birthday: string) {
  const birthYear = dayjs(birthday).get('year')
  const birthMonth = dayjs(birthday).get('month')
  const birthDate = dayjs(birthday).get('date')

  const currentYear = dayjs().get('year')
  const currentMonth = dayjs().get('month')
  const currentDate = dayjs().get('date')

  let age = currentYear - birthYear

  if (currentMonth < birthMonth) {
    age--
  } else if (currentMonth === birthMonth && currentDate < birthDate) {
    age--
  }

  return age
}
